import { useAuth0 } from '@auth0/auth0-react';
import { Check } from 'lucide-react';
import PageHeader from '../components/PageHeader';
import { Link } from '@tanstack/react-router';

const FEATURES = [
  'A personalized, adaptive race plan',
  'Garmin and Strava integrations',
  'Workouts published directly to Garmin',
];

const Checkout = () => {
  const { user } = useAuth0();
  const paymentLink = import.meta.env.REACT_APP_STRIPE_PAYMENT_LINK;

  const checkoutUrl = paymentLink ? new URL(paymentLink) : null;
  if (checkoutUrl && user?.email) {
    checkoutUrl.searchParams.set('prefilled_email', user.email);
  }

  return (
    <div className="mx-auto flex min-h-[70vh] w-full max-w-2xl flex-col justify-center px-4 py-10">
      <PageHeader
        eyebrow="Membership"
        title="Make the plan personal"
        description="Everything you need to train consistently, adapt intelligently, and arrive ready."
      />
      <section className="surface-card w-full p-7 sm:p-10">
        <p className="text-xs font-bold uppercase tracking-[0.16em] text-brand-cobalt">
          One step before your plan
        </p>
        <h2 className="mt-3 text-3xl font-black tracking-[-0.04em] text-brand-midnight">
          Start your RaceTrainer membership
        </h2>
        <p className="mt-3 text-base leading-7 text-gray-600">
          Subscribe before generating your plan so your training and connected
          services are ready from day one.
        </p>

        <div className="mt-7 flex items-end gap-2 border-y border-gray-100 py-6">
          <span className="text-5xl font-black tracking-[-0.05em] text-brand-midnight">
            $5
          </span>
          <span className="pb-1 text-sm font-semibold text-gray-500">
            / month
          </span>
        </div>

        <ul className="mt-6 space-y-3">
          {FEATURES.map((feature) => (
            <li
              key={feature}
              className="flex items-start gap-3 text-sm text-gray-700"
            >
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand-voltSoft">
                <Check className="h-3.5 w-3.5 text-brand-midnight" />
              </span>
              {feature}
            </li>
          ))}
        </ul>

        {checkoutUrl ? (
          <a
            href={checkoutUrl.toString()}
            className="button-primary mt-8 flex min-h-12 w-full px-6 py-3.5 text-center"
          >
            Continue to secure checkout
          </a>
        ) : (
          <div className="mt-8 rounded-xl border border-red-200 bg-red-50 p-4 text-sm text-red-700">
            <p>Checkout is temporarily unavailable.</p>
            <Link
              to="/support"
              className="mt-2 inline-flex font-bold underline"
            >
              Contact support
            </Link>
          </div>
        )}
        <p className="mt-4 text-center text-xs text-gray-500">
          Secure payment powered by Stripe. Cancel anytime.
        </p>
      </section>
    </div>
  );
};

export default Checkout;
